import React from 'react';
import { BookOpenCheck, CalendarDays, Monitor } from 'lucide-react';
import { EditorialShortlist } from './EditorialShortlist';
import { countWord } from '../utils/editorialGuide.mjs';

const formatDate = (iso) => new Date(`${iso}T00:00:00Z`).toLocaleDateString('en-US', { timeZone: 'UTC', year: 'numeric', month: 'short', day: 'numeric' });

// The whole visible body of an editorial guide route (hero, breadcrumb, article). It is rendered by the client
// (DynamicPage) AND at build time (src/ssr/editorialBody.jsx -> static HTML in the route's initial response), so the
// markup exists in exactly one place. It must stay free of router/context dependencies so it can render on the server.
export function EditorialGuidePage({ guide }) {
  return (
    <div data-editorial-page className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-slate-900 dark:to-slate-800">
      <header className="border-b border-white/10 bg-gradient-to-r from-orange-700 to-red-700 text-white dark:from-orange-800/70 dark:to-red-900/60" role="banner">
        <div className="mx-auto max-w-5xl px-4 py-8 md:py-10">
          <p className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-[13px] font-medium backdrop-blur-sm">
            <BookOpenCheck className="h-4 w-4" aria-hidden="true" />Buying guide · Research-based
          </p>
          <h1 className="mt-3 max-w-3xl text-[1.75rem] font-bold leading-tight tracking-tight sm:text-4xl md:text-[2.5rem]">{guide.title}</h1>
          <p className="mt-3 max-w-2xl text-[1.0625rem] leading-relaxed text-white/90 md:text-lg">{guide.summary}</p>
          <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-1.5 text-[15px] text-white/90">
            <li className="inline-flex items-center gap-2"><Monitor className="h-4 w-4" aria-hidden="true" />{countWord(guide.models.length).replace(/^./, (c) => c.toUpperCase())} monitors compared</li>
            <li className="inline-flex items-center gap-2"><CalendarDays className="h-4 w-4" aria-hidden="true" />Dell specs read {formatDate(guide.research.date)}</li>
          </ul>
        </div>
      </header>

      <nav aria-label="breadcrumb" className="mx-auto max-w-5xl px-4 pt-6">
        <ol className="flex flex-wrap items-center gap-2 text-[15px] text-gray-600 dark:text-gray-400">
          <li><a href="/" className="hover:text-blue-600 dark:hover:text-blue-400">Home</a></li>
          <li aria-hidden="true">›</li>
          <li><a href={`/category/${guide.breadcrumb.categorySlug}`} className="hover:text-blue-600 dark:hover:text-blue-400">{guide.breadcrumb.categoryName}</a></li>
          <li aria-hidden="true">›</li>
          <li aria-current="page" className="font-medium text-gray-900 dark:text-white">{guide.title}</li>
        </ol>
      </nav>

      <EditorialShortlist guide={guide} />
    </div>
  );
}
